module.exports = __webpack_public_path__ + "static/octrino-cover-01aac9b47caa7b4fb299262a41cf7558.jpg";